const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

if (!customElements.get('loyalty-rewards-carousel')) {
  customElements.define(
    'loyalty-rewards-carousel',
    class LoyaltyRewardsCarousel extends window.BAO.CustomElement() {
      connectedCallback () {
        super.connectedCallback()

        this.carousel = this.setupCarousel()
      }

      setupListeners () {
        super.setupListeners()

        if (this.els.tab) {
          this.els.tab.elements.forEach(el => {
            this.listeners.add(el, 'click', this.onTabClick.bind(this))
          })
        }

        if (this.els.rule) {
          this.els.rule.elements.forEach(el => {
            this.listeners.add(el, 'click', this.onRuleClick.bind(this))
          })
        }
      }

      setupCarousel () {
        const instance = new KeenSlider(
          this.els.slides.element,
          this.options(),
          [setInitialised()],
        )

        return instance
      }

      options () {
        return {
          selector: `${this.els.slide.selector}:not([aria-hidden='true'])`,
          defaultAnimation: {
            duration: 1500,
          },
          loop: false,
          mode: 'snap',
          slides: {
            perView: 1.1,
            spacing: 10,
          },
          breakpoints: {
            '(min-width: 901px)': {
              slides: {
                perView: 3.001,
                spacing: 10,
              },
            },
          },
        }
      }

      onTabClick (event) {
        const tab = event.currentTarget
        const tier = tab.dataset.tier

        this.els.tab.elements.forEach(el => {
          el.setAttribute('aria-current', el === tab)
        })

        this.els.slide.elements.forEach(el => {
          el.setAttribute('aria-hidden', el.dataset.tier !== tier)
        })

        this.carousel.update(this.options(), 0)
      }

      onRuleClick (event) {
        const rule = event.currentTarget
        const id = rule.dataset.ruleId

        const button = document.querySelector(
          `.lion-rule-item[data-rule-id="${id}"] button`,
        )
        if (button) {
          button.click()
        }
      }
    },
  )
}
